import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-box" }
const _hoisted_3 = { class: "title-name" }
const _hoisted_4 = ["onClick", "onMouseenter"]
const _hoisted_5 = { class: "general-style" }
const _hoisted_6 = { class: "general-style-right" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "industry-style" }
const _hoisted_9 = { class: "general-style-right" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import router from '@/router';
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
const solutionPath = '/solution'
const newsPath = '/company-news'

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderView',
  setup(__props) {

const store = useStore()
const activePath = ref('')
let lastScrollTop = 0;
const titleKeyList = ref(['', 'AR小程序', 'VR虚拟仿真', '虚拟博物馆', 'AR导航导览', '元宇宙展厅'])
const industryTitleList = ref(['文娱解决方案', '工业解决方案', '教育解决方案'])
const titleActiveIndex = ref(-1)
const hoverUrl = ref('')
let timer: any = null;
const newsList = ['公司新闻', '行业新闻']

const titleList: any = [
  {
    name: '首页',
    url: '/'
  },
  {
    name: '混空Studio',
    url: '/studio'
  },
    {
    name: '混空VPS',
    url: '/vps'
  },
  {
    name: '解决方案',
    url: solutionPath
  },
  {
    name: '关于我们',
    url: '/about-us'
  },
  {
    name: '新闻资讯',
    url: newsPath
  }
]

const mouseenter = (path) => {
  hoverUrl.value = path;
  clearTimeout(timer)
}

const mouseleave = (path) => {
  timer = setTimeout(() => {
    hoverUrl.value = '';
  }, 200)
}

const handleRouterIndex = (index, url, offset = 0) => {
  titleActiveIndex.value = (index + offset)
  store.state.programmeIndex = titleActiveIndex.value
  activePath.value = `${url}?type=${titleActiveIndex.value}`;
  router.push(activePath.value);
  window.localStorage.setItem('activePath', activePath.value);
}

const toPath = (index: number) => {
  if (hoverUrl.value == solutionPath || hoverUrl.value == newsPath) return;
  window.scrollTo(0, 0);
  activePath.value = titleList[index].url;
  router.push(activePath.value);
  window.localStorage.setItem('activePath', activePath.value);
  store.state.programmeIndex = -1;
  titleActiveIndex.value = -1;
}

const scrollEvent = (e: any) => {
  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  (document.querySelector('.header') as any).style.transition = 'all 1s'
  if (scrollTop > lastScrollTop) {
    (document.querySelector('.header') as any).style.opacity = 0;
  } else {
    (document.querySelector('.header') as any).style.opacity = 1;
  }
  lastScrollTop = scrollTop;
}

onMounted(() => {
  window.addEventListener('scroll', scrollEvent, false)
  activePath.value = window.localStorage.getItem('activePath') || ''
  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  if (path.query.type == undefined) {
    titleActiveIndex.value = activePath.value.includes(solutionPath) ? 3 : 0;
  } else {
    titleActiveIndex.value = +path.query.type
  }
  store.state.programmeIndex = titleActiveIndex.value;
})

onUnmounted(() => {
  window.removeEventListener('scroll', scrollEvent, false)
})

watch(() => store.state.activePath, (newState) => {
  if (newState != activePath.value) {
    activePath.value = newState;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(titleList, (item, index) => {
          return _createElementVNode("div", {
            class: _normalizeClass((item.url != '/' && activePath.value.includes(item.url)) || (item.url == activePath.value) ? 'active' : ''),
            onClick: ($event: any) => (toPath(index)),
            key: index,
            onMouseenter: ($event: any) => (mouseenter(item.url))
          }, _toDisplayString(item.name), 43, _hoisted_4)
        }), 64))
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("a", {
        class: "enter-studio",
        href: "https://mixedspace.njyjxr.com"
      }, [
        _createElementVNode("div", null, "进入混空Studio"),
        _createElementVNode("div", { class: "to-next" })
      ], -1)),
      (hoverUrl.value.includes(solutionPath))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "solution-title",
            onMouseleave: _withModifiers(mouseleave, ["stop"])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "general-style-left" }, [
                _createElementVNode("div", { class: "title" }, "通用解决方案"),
                _createElementVNode("div", { class: "general-style-left-icon" })
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titleKeyList.value, (item, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(titleActiveIndex.value == (index + 3) && activePath.value.includes(hoverUrl.value) ? 'active' : ''),
                    key: index,
                    onClick: ($event: any) => (handleRouterIndex(index, solutionPath, 3))
                  }, _toDisplayString(item), 11, _hoisted_7)), [
                    [_vShow, item]
                  ])
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "general-style-left" }, [
                _createElementVNode("div", { class: "title" }, "行业解决方案"),
                _createElementVNode("div", { class: "general-style-left-icon" })
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryTitleList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(titleActiveIndex.value == index && activePath.value.includes(hoverUrl.value) ? 'active' : ''),
                    key: index,
                    onClick: ($event: any) => (handleRouterIndex(index, solutionPath))
                  }, _toDisplayString(item), 11, _hoisted_10))
                }), 128))
              ])
            ])
          ], 32))
        : _createCommentVNode("", true),
      (hoverUrl.value.includes(newsPath))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "news-title",
            onMouseleave: _withModifiers(mouseleave, ["stop"])
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(newsList, (item, index) => {
              return _createElementVNode("div", {
                onClick: ($event: any) => (handleRouterIndex(index + 5, newsPath)),
                key: index
              }, _toDisplayString(item), 9, _hoisted_11)
            }), 64))
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})